import React from "react";
import { MDBBadge, MDBCol, MDBIcon, MDBRow } from "mdbreact";
import { currency } from "../../../../../../services/utilities";
import { clean, getPreference } from "../utils";

const Info = ({ icon, title, children }) => (
  <div className="mb-3">
    <div className="text-primary font-weight-bold small text-uppercase mb-1">
      <MDBIcon icon={icon} className="mr-2" />
      {title}
    </div>
    <div style={{ whiteSpace: "pre-line" }}>{children}</div>
  </div>
);

const Fact = ({ label, children }) =>
  children ? (
    <tr>
      <td className="text-muted pr-3 py-1 align-top text-nowrap">{label}</td>
      <td className="py-1">{children}</td>
    </tr>
  ) : null;

export default function Collapsable({ service, menus = [] }) {
  const {
    purpose,
    ssx,
    lo_ssx,
    hi_ssx,
    preparation,
    procedure,
    specimen,
    organ,
    frequency,
    preference,
    note,
  } = service;

  const results = [clean(lo_ssx), clean(hi_ssx)].filter(Boolean),
    organs = (Array.isArray(organ) ? organ : []).filter(Boolean),
    prep = clean(preparation);

  return (
    <MDBRow>
      <MDBCol lg="7">
        <Info icon="bullseye" title="What it is for">
          {clean(purpose) || <span className="text-muted">Not described yet.</span>}
        </Info>
        {clean(ssx) && (
          <Info icon="notes-medical" title="Requested when the patient has">
            {ssx}
          </Info>
        )}
        {results.length > 0 && (
          <Info icon="chart-line" title="What results may show">
            <ul className="mb-0 pl-3">
              {results.map((result) => (
                <li key={result}>{result}</li>
              ))}
            </ul>
          </Info>
        )}
        {clean(procedure) && (
          <Info icon="list-ol" title="Procedure">
            {procedure}
          </Info>
        )}
      </MDBCol>

      <MDBCol lg="5">
        <div
          className="p-3 mb-3 rounded"
          style={{
            background: prep ? "#fff8e1" : "#f1f8f4",
            border: `1px solid ${prep ? "#ffe08a" : "#cfe8d6"}`,
          }}
        >
          <div className="font-weight-bold small text-uppercase mb-1">
            <MDBIcon icon="user-check" className="mr-2" />
            Tell the patient
          </div>
          {prep || "No special preparation needed."}
        </div>

        <table className="mb-3 small w-100">
          <tbody>
            <Fact label="Specimen">{clean(specimen)}</Fact>
            <Fact label="Organ">{organs.join(", ")}</Fact>
            <Fact label="Frequency">{clean(frequency)}</Fact>
            <Fact label="Normal values by">{getPreference(preference)}</Fact>
            <Fact label="Note">{clean(note)}</Fact>
          </tbody>
        </table>

        <div className="text-primary font-weight-bold small text-uppercase mb-1">
          <MDBIcon icon="tags" className="mr-2" />
          Sold in
        </div>
        {menus.length ? (
          <ul className="list-unstyled mb-0">
            {menus.map((menu) => {
              const others = (menu.packages || []).length - 1;
              return (
                <li
                  key={menu._id}
                  className="d-flex justify-content-between border-bottom py-1"
                >
                  <span>
                    <b>{menu.abbreviation}</b>
                    <small className="d-block text-muted">
                      {menu.description}
                      {others > 0 &&
                        ` · package with ${others} other service${others > 1 ? "s" : ""}`}
                    </small>
                  </span>
                  <span className="text-right text-nowrap ml-2">
                    {Number(menu.opd) > 0 ? currency.format(menu.opd) : "No price"}
                    <small className="d-block">
                      {menu.hasDiscount ? (
                        <MDBBadge color="success">discountable</MDBBadge>
                      ) : (
                        <MDBBadge color="light" className="text-muted">
                          fixed price
                        </MDBBadge>
                      )}
                    </small>
                  </span>
                </li>
              );
            })}
          </ul>
        ) : (
          <div className="text-muted small">
            Not included in any menu of this branch, so it can not be sold yet.
          </div>
        )}
      </MDBCol>
    </MDBRow>
  );
}
